<div class="w-full h-full inline-block align-middle mt-4 md:mt-auto">
    <div class="flex justify-center w-full md:mt-11 pb-10">
        <img src="assets/icons/Icons/other-payment-options/Mobicred_logo.png" alt="mobicred logo" class="w-3/4 md:w-auto">
    </div>
    <router-outlet></router-outlet>
</div>
